import previews from './card-video-previews.json';

/** Only substitute published card derivatives; unknown/user media stays intact. */
export function getCardVideoPreview(source: string): { src: string; poster: string } | null {
  try {
    const url = new URL(source, 'https://dobidobi.local');
    if (!['https:', 'http:'].includes(url.protocol)) return null;
    if (!(source.startsWith('/') && !source.startsWith('//')) && ![
      'dobidobi.ai', 'www.dobidobi.ai', 'cdn.dobidobi.ai', 'media.dobidobi.ai',
      'img.dobidobi.ai', 'localhost', '127.0.0.1',
      'octo-static-1412329033.cos.ap-nanjing.myqcloud.com',
    ].includes(url.hostname)) return null;
    const pathname = decodeURIComponent(url.pathname);
    const known = (previews as Record<string, { src: string; poster: string }>)[pathname];
    if (known) return known;
    if (/\/template_preview_video\/cards-v1\/[a-f0-9]{64}\.mp4$/.test(pathname)) {
      return { src: source, poster: source.replace(/\.mp4(?=[?#]|$)/, '-poster.jpg') };
    }
    // Packaged derivative URLs can pass through multiple cover components.
    return Object.values(previews).find(preview => preview.src === pathname) ?? null;
  } catch {
    return null;
  }
}

export function getCardVideoSource(source: string): string {
  return getCardVideoPreview(source)?.src ?? source;
}
